import { type Instance, types } from 'mobx-state-tree';
import { MODAL_NAME, OVERLAY_MODAL } from '../../constants/modals';

const ModalStore = types
  .model('ModalStore', {
    modals: types.optional(
      types.array(
        types.enumeration<MODAL_NAME | OVERLAY_MODAL>(
          'Modals',
          Object.values({ ...MODAL_NAME, ...OVERLAY_MODAL }),
        ),
      ),
      [],
    ),
  })
  .views((self) => ({
    get isEmpty(): boolean {
      return self.modals.length === 0;
    },
  }))
  .actions((self) => {
    const addModal = (modalName: MODAL_NAME | OVERLAY_MODAL) => {
      self.modals.push(modalName);
    };

    const removeModal = (modalName: MODAL_NAME | OVERLAY_MODAL) => {
      if (!self.isEmpty) {
        const index = self.modals.indexOf(modalName);
        if (index > -1) {
          self.modals.splice(index);
        }
      }
    };

    const closeModal = () => {
      self.modals.clear();
    };

    return { addModal, removeModal, closeModal };
  })
  .actions((self) => {
    const clearOverlayModal = () => {
      if (!self.isEmpty) {
        Object.values(OVERLAY_MODAL).forEach((overlayModal) =>
          self.removeModal(overlayModal),
        );
      }
    };

    return { clearOverlayModal };
  });

export interface IModalStore extends Instance<typeof ModalStore> {}

export default ModalStore;
